export const environment = {
    production: false,
    appUrl: 'https://staging-frontend.talkgenie.ai',
    apiUrlBase: 'https://staging-api.talkgenie.ai',
    apiUrl: 'https://staging-api.talkgenie.ai',
    socketEndpoint: 'wss://staging-api.talkgenie.ai',
    livekitWebSocketUrl:"wss://staging-nquplcoq.livekit.cloud",
    stripeSecret:  'pk_test_51QpYRBGAt5IGKFUwQNuqSosVIK8ewptra0EyAQlz2Aiaiv7gkZbIYeZGqI32w2p0QU4kKVsMBwQg9amWJEdpnJ4t0006CpuuuQ',
    server_ip:"34.30.221.216",
    gcsBucket: 'talkgenie-private',
    recaptchaSiteKey: '6LdbmzMsAAAAAAxvTLNETwYmS05y2QRWbITWlb9o', // Replace with your actual reCAPTCHA site key,
    vapidPublicKey: 'BOgHbOXHcNNyqpok3QVY9FQd24mhzRUAO6ges67c97V_5dwXwwwCgxTtoJFrbHKP0jW-R276clqS0qPel_sSHbE'
};
